import * as React from 'react';
import { IFrame } from '@grandvisionhq/common';
import { compose } from '@grandvisionhq/utils';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';
import { withAnchor } from '../../hocs/with-anchor.js';

const CmsIframe = ({ component  })=>{
    const { iframe: content  } = component.getModels();
    if (!content) {
        return null;
    }
    const { source , scrolling , height , position , title  } = content;
    // TODO: bloomreach needs to be updated to have a required `title` field. For now, fallback to `source`
    return /*#__PURE__*/ React.createElement(IFrame, {
        source: source,
        scrolling: scrolling,
        height: height,
        position: position,
        title: title !== null && title !== void 0 ? title : source
    });
};
var CmsIframe$1 = compose(withBreakpointVisibility, withHidableContent, withAnchor)(CmsIframe);

export { CmsIframe, CmsIframe$1 as default };
//# sourceMappingURL=Iframe.js.map
